import React, {useState, useEffect} from "react";
import { useTranslation } from 'react-i18next';
import {useHistory} from "react-router-dom";
import {isEmail} from "validator";

// Libs
// Hooks
import {useAuth} from "../auth/auth";
import {useFilters} from "../filters/filters";

// Components
import TextInput from "../common/components/text-input";
import Button from "../common/components/button";

const LoginPage = () => {

    // i18n
    const {t} = useTranslation("auth");

    const history = useHistory();
    const to = "/forgot";

    // State
    const [email, setEmail] = useState({value: "", isValid: false});
    const [password, setPassword] = useState("");
    const [validForm, setValidForm] = useState(false);

    function validateEmail(email) {
        let isValid = !!isEmail(email);
        setEmail({value: email, isValid: isValid});
    }

    function validateForm() {
        email.isValid && password.length >= 6 ? setValidForm(true) : setValidForm(false);
    }

    useEffect(() => {
        validateForm();
    }, [email, password]);

    // Hooks
    const auth = useAuth();

    const {
        removeDateFilters,
        removeDeliveryNotesFilters,
        removeInvoicesFilters,
        removeTechnicalSheetsFilters
    } = useFilters();

    useEffect(() => {
        removeDeliveryNotesFilters();
        removeInvoicesFilters();
        removeDateFilters();
        removeTechnicalSheetsFilters();
    }, []);

    const handleEnter = (event) => {
        if (event.keyCode === 13 && validForm) auth.login(email.value, password);
    };

    return (
        <div style={{
            height: "calc(100vh - 200px)",
            width: "100%",
            display: "flex",
            flexDirection: "column"
        }}>
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                margin: "auto"
            }}>
                <h2 style={{fontSize: "18px"}}>{t("login.title")}</h2>
                <TextInput
                    placeholder={t("login.placeholderEmail")}
                    style={loginItemStyle}
                    value={email.value}
                    setValue={validateEmail}
                    icon={"user"}
                    onKeyDown={handleEnter}
                />
                <TextInput
                    placeholder={t("login.placeholderPassword")}
                    style={loginItemStyle}
                    type={"password"}
                    value={password}
                    setValue={setPassword}
                    icon={"key"}
                    onKeyDown={handleEnter}
                />
                <Button
                    style={{marginTop: 30, width: "120px"}}
                    intent="primary"
                    text={t("login.login")}
                    disabled={validForm}
                    action={() => auth.login(email.value, password)}
                />
                {!!auth && !!auth.loginError && (
                    <div style={{
                        backgroundColor: "#ffdddd",
                        color: "#ff0000",
                        border: "1px solid #ff0000",
                        borderRadius: 3,
                        fontWeight: "bold",
                        marginTop: 15,
                        padding: 8
                    }}>
                        {auth.loginError}
                    </div>
                )}
            </div>
            <Button
                style={{marginTop: 30, width: "100%"}}
                intent="primary"
                text={t("login.forgot")}
                action={() => !!to && history.push(to)}
            />
        </div>
    );
};

export default LoginPage;

const loginItemStyle = {
    marginTop: 15,
    display: "flex",
    flexDirection: "column"
}